<template>
  <b-modal
    id="addFolderModal"
    ref="addFolderModal"
    title="Adicionar nova pasta"
    size="lg"
    centered
    @hide="clear"
  >
  <div class="row">
    <div class="col-md-3">
      <label for="txtCaixaPasta">{{$lang.archiveDocumentsManagement.addDocument.labelCaixaPasta}}:</label>
      <div class="input-group">
        <b-form-input
          type="text"
          name="txtCaixaPasta"
          v-model.number="form.caixaPasta.value"
          :required="form.caixaPasta.required"
          :state="form.caixaPasta.state"
        />
      </div>
    </div>
    <div class="col-md-9">
      <label for="txtNome"><small v-show="form.nome.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelNome}}:</label>
      <div class="input-group">
        <b-form-input
          type="text"
          name="txtNome"
          v-model="form.nome.value"
          :required="form.nome.required"
          :state="form.nome.state"
        />
      </div>
    </div>
  </div>
  <template #modal-footer="{ cancel }">
    <b-button variant="danger" @click="cancel()">
      <i class="fas fa-times-circle" />
      {{ $lang.archiveDocumentsManagement.addDocument.cancelTitle }}
    </b-button>
    <b-button variant="third" @click="onSave">
      <i class="fas fa-check-circle" />
      {{ $lang.archiveDocumentsManagement.addDocument.okTitle }}
    </b-button>
  </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'

import DocumentsFolderRepository from '@/shared/http/repositories/business/documentsfolder'

import AddFolderForm from './AddFolderForm'
import AddFolderModel from '@/shared/models/business/foldermodel.js'

export default {
  name: 'AddDocumentModal',
  mixins: [
    ActionsForm
  ],
  directives: {
    mask
  },
  data () {
    return {
      form: null,
      data: null,
      folder: null,
      item: null
    }
  },
  created () {
    this.clear()
  },
  methods: {
    async show (item, folder) {
      loading.push()

      try {
        this.item = item

        if (folder) {
          this.folder = folder
          await this.onEdit(folder)
        }

        this.$refs['addFolderModal'].show()
      } catch (error) {
        console.log(error)
      } finally {
        loading.pop()
      }
    },
    hide () {
      this.$refs['addFolderModal'].hide()
      this.clear()
    },
    clear () {
      this.form = _.cloneDeep(AddFolderForm)
      this.data = _.cloneDeep(AddFolderModel)

      this.folder = null
      this.item = null
    },
    onCreate () {
      loading.push()

      this.data.pastaPaiID = this.item ? this.item.id : null
      this.data.empresaID = this.CompanySelected

      DocumentsFolderRepository.AddFolder(this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.emitSaved()
          } else {
            toast.error(response.data.message)
          }

          this.$nextTick(() => {
            loading.close()
            this.hide()
          })
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()

      this.data.empresaID = this.CompanySelected

      DocumentsFolderRepository.UpdateFolder(this.data.id, this.data)
        .then((response) => {
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.emitSaved()
          } else {
            toast.error(response.data.message)
          }

          this.$nextTick(() => {
            loading.close()
            this.hide()
          })
        })
        .catch(this.onException)
    },
    emitSaved () {
      const event = {
        item: _.cloneDeep(this.item)
      }

      this.$emit('saved', event)
    }
  }
}
</script>

<style>
#add-new-document{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}
#container-destiny-select{
  display: flex;
  flex-direction: column;
}

.section-destinations{
    min-height: 100px;
}

.container-buttons-form{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

.select-customer{
    display: flex;
    gap: 2px;
}

.select-empreendimento{
    width: 100%;
    border-color: #c0bcbc;
}

</style>



// WEBPACK FOOTER //
// src/views/private/archiveDocumentsManagement/components/AddFolder/AddFolderModal.vue